import api from "./api";

export interface RoleRow {
  id: string;
  key: string;
  name: string;
  description: string | null;
  isSystem: boolean;
  isActive: boolean;
  sortOrder: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface ModulePermissionRow {
  id?: string;
  role: string;
  moduleId?: string;
  module?: string | { key: string; name?: string };
  canCreate: boolean;
  canRead: boolean;
  canUpdate: boolean;
  canDelete: boolean;
  extraActions?: string[];
}

export type CreateRolePayload = {
  key: string;
  name: string;
  description?: string;
  isSystem?: boolean;
  isActive?: boolean;
  sortOrder?: number;
  copyFromRole?: string;
};

export type UpdateRolePayload = {
  name?: string;
  description?: string;
  isActive?: boolean;
  sortOrder?: number;
  isSystem?: boolean;
};

function unwrapData(res: any) {
  return res?.data?.data ?? res?.data ?? res;
}

export const roleAPI = {
  list: async (params?: { search?: string; isActive?: string }): Promise<RoleRow[]> => {
    const response = await api.get("/roles", { params });
    const data = unwrapData(response);
    return data?.roles || [];
  },

  getById: async (id: string): Promise<RoleRow> => {
    const response = await api.get(`/roles/${id}`);
    return unwrapData(response);
  },

  create: async (body: CreateRolePayload): Promise<RoleRow> => {
    const response = await api.post("/roles", body);
    return unwrapData(response);
  },

  update: async (id: string, body: UpdateRolePayload): Promise<RoleRow> => {
    const response = await api.put(`/roles/${id}`, body);
    return unwrapData(response);
  },

  remove: async (id: string): Promise<void> => {
    await api.delete(`/roles/${id}`);
  },
};

export const permissionAPI = {
  listByRole: async (role: string): Promise<ModulePermissionRow[]> => {
    const response = await api.get(`/permissions/role/${encodeURIComponent(role)}`);
    const data = unwrapData(response);
    return data?.permissions || [];
  },

  update: async (
    id: string,
    body: Partial<{
      canCreate: boolean;
      canRead: boolean;
      canUpdate: boolean;
      canDelete: boolean;
      extraActions: string[];
    }>
  ) => {
    const response = await api.put(`/permissions/${id}`, body);
    return unwrapData(response);
  },

  seed: async () => {
    const response = await api.post("/permissions/seed");
    return unwrapData(response);
  },
};
